/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Manages fields, a replacement for JSON Schema.
 * 
 * Created by Justin K Kazmierczak.
 */
// var _ = require("../uam/module.js")(module.exports, {
//     namespace: "fields",
//     title: "Fields",
//     description: "Handles custom field specifications, validations, and properties.",
//     errors: {
//         missingTitle: {
//             title: "Missing Title",
//             description: "Each field spec must have a title.",
//             template: "Missing title in ${namespace}"
//         },
//         missingDescription: {
//             title: "Missing Description",
//             description: "Each field spec must have a description.",
//             template: "Missing description in ${namespace}"
//         },
//         unknownFieldType: {
//             title: "Unknown Field Type",
//             description: "Field type is unknown or not registered.",
//             template: "Unknown field type '${type}'"
//         },
//         missingValidate: {
//             title: "Missing Validate Function",
//             description: "Each module must export a validate function.",
//             template: "Validate not found for ${namespace}"
//         },
//         invalidFieldDefinition: {
//             title: "Invalid Field Definition",
//             description: "A field definition inside a field schema is invalid.",
//             template: "Invalid field '${key}' in definition: ${reason}"
//         },
//         invalidModule: {
//             title: "Invalid Module",
//             description: "Module does not have a valid definition or validate function.",
//             template: "Module ${namespace} is invalid"
//         },
//         invalidLocationType: {
//             title: "Invalid Location Type",
//             description: "Location must be a string or an array of strings."
//         },
//         invalidSepcDefinition: {
//             title: "Invalid Spec Definition",
//             description: "The field spec is not valid.",
//         }
//     },
//     registry: true
// });

// var errModule = require("./errors.js");
var GenerateStacktrace = require("./functions/generateStacktrace.js").function;
// var config = false;
// var registryFactory = require("./registry.js");
// var validate = require("./functions/validate.js").function;
var generateSafeError = require("./functions/generateSafeError.js").function;
// var supportedTypes = require("./functions/validate.js").supportedTypes;
var fm = false;
// var fm = require("./filemanager.js");
try {
    fm = require("../uam/filemanager.js"); //Won't work in the browser.
} catch (error) {
    //not supported in browser
}

//Prevents a circular dependency as module requires fields itself
//this reports itself like a module, but does all the items internally
//it doesn't save itself to the module registry.

var _ = {
    define: {
    namespace: "fields",
    title: "Fields",
    description: "Handles custom field specifications, validations, and properties.",
    errors: {
        notInitalized: {
            title: "Not Initialized",
            description: "Fields module has not been initialized. Properties and Fields may not be loaded.",
        },
        missingTitle: {
            title: "Missing Title",
            description: "Each field spec must have a title.",
            template: "Missing title in ${namespace}"
        },
        missingDescription: {
            title: "Missing Description",
            description: "Each field spec must have a description.",
            template: "Missing description in ${namespace}"
        },
        unknownFieldType: {
            title: "Unknown Field Type",
            description: "Field type is unknown or not registered.",
            template: "Unknown field type '${type}'"
        },
        unkownProperty: {
            title: "Unknown Property",
            description: "A property in the field spec is not recognized.",
            template: "Unknown property '${property}' in definition at '${namespace}'"
        },
        missingValidate: {
            title: "Missing Validate Function",
            description: "Each module must export a validate function.",
            template: "Validate not found for ${namespace}"
        },
        invalidFieldDefinition: {
            title: "Invalid Field Definition",
            description: "A field definition inside a field schema is invalid.",
            template: "Invalid field '${key}' in definition: ${reason}"
        },
        invalidModule: {
            title: "Invalid Module",
            description: "Module does not have a valid definition or validate function.",
            template: "Module ${namespace} is invalid"
        },
        invalidLocationType: {
            title: "Invalid Location Type",
            description: "Location must be a string or an array of strings."
        },
        invalidSepcDefinition: {
            title: "Invalid Spec Definition",
            description: "The field spec is not valid."
        },
        emptyTypeArray: {
            title: "Empty Type Array",
            description: "Field type array cannot be empty.",
            template: "Field type array is empty at '${key}'"
        },
        invalidFieldType: {
            title: "Invalid Field Type",
            description: "Field type must be a list of strings or a single string.",
            template: "Field type must be a list of strings or a single string. Recieved: '${type}'"
        },
        unsupportedType: {
            title: "Unsupported Type",
            description: "The data specified is not supported for this field type.",
            template: "The data must be a valid ${type}. Validation failed because: ${reason} (first error)."
        },
        notSpecified: {
            title: "Unknown Field",
            description: "The field is not specified in the schema.",
            template: "The field '${field}' is not specified in the schema."
        },
        unableToInitialize: {
            title: "Unable to Initialize",
            description: "The fields module could not be initialized.",
            template: "Unable to initialize fields module: ${error}"
        },
        alreadyInitialized: {
            title: "Already Initialized",
            description: "The fields module has already been initialized.",
        }
    },
    registry: true
    }
}

_.namespace = _.define.namespace;
_.registry = require("../uam/registry.js")(_.namespace);
_.errors = require("../uam/errors.js").createFromDefine(_.define);

// var config = require("../uam/config.js");

// var registry = _.registry;
var fieldMap = {};
var propertyMap = {};
var appFolderLocations = ["@!/fields"];
var shorthand = require("../uam/shorthand.js");

var registeredFields = require("../.includes/fields.js");

var initialized = false;

/**
 * Initializes and loads field modules into memory.
 */
function init(registry = false) {

    // if (initialized) {
    //     _.errors.alreadyInitialized.throw();
    // }

    try {
        if (!registry) { 
            Load(registeredFields._.registry);
        } else {
            Load(registry);
        }
        initialized = true;    
    } catch (error) {

        console.error(_.errors.unableToInitialize.safe({
            error: GenerateStacktrace(error)
        }));
    }
 

    // loadModules();

}
module.exports.init = init;

// function AddLocation(location) {
//     if (typeof location === "string") {
//         appFolderLocations.push(location);
//     } else if (Array.isArray(location)) {
//         appFolderLocations.push(...location);
//     } else {
//         _.errors.invalidLocationType.throw({ location: location });
//     }
// }
// module.exports.AddLocation = AddLocation;

/**
 * Gets a field type by its name or an array of names.
 * @param {*} type The type name or an array of type names to retrieve.
 * @returns {object|array} The field type module or an array of field type modules.
 */
function GetType(type) {
    if (!initialized) {
        _.errors.notInitalized.throw();
    }

    if (typeof type === "string") {
        return fieldMap[type];
    } else if (Array.isArray(type)) {
        //if the type is an array, return all types
        var types = [];
        for (var i = 0; i < type.length; i++) {
            if (fieldMap[type[i]]) {
                types.push(fieldMap[type[i]]);
            }
        }
        return types;
    }
} module.exports.GetType = GetType;


// var loadedTimes = 0;

/**
 * Loads all registered modules and validates definitions.
 * @param {object} registry The registry to load modules from.
 * @param {boolean} append If false, fields will be replaced with the new registry. Defaults to true.
 */
function Load(registry, append = true) {
    
    //if append is false clear the arrays
    if (!append) {
        fieldMap = {};
        propertyMap = {};
    }

    // registry.addFromDir(appFolderLocations, "js", true);
    var namespaces = registry.list();
    fieldMap = {};
    propertyMap = {};

    // var rejectedNS = [];

    for (var i = 0; i < namespaces.length; i++) {
        var ns = namespaces[i];
        var mod = registry.find(ns);
        var errors = [];

        // if (!mod) {
        //     //is the module in the registry but not loaded?
        //     mod = registry.find(ns);
        // }

        if (!mod || !mod.define) {
            console.error("Invalid module", ns);
            registry.remove(ns);
            // rejectedNS.push({
            //     namespace: ns,
            //     errors: [_.errors.invalidModule.safe({ namespace: ns })]
            // })
            continue;
        }

        var def = mod.define;

        if (!def.title) {
            console.error("Missing title in", ns);
            errors.push(_.errors.missingTitle.safe({ namespace: ns }));
        }

        if (!def.description) {
            console.error("Missing description in", ns);
            errors.push(_.errors.missingDescription.safe({ namespace: ns }));
        }

        if (typeof mod.validate !== "function") {
            console.error("Missing validate in", ns);
            errors.push(_.errors.missingValidate.safe({ namespace: ns }));
        }

        // reject invalid modules
        if (errors.length > 0) {
            registry.remove(ns);
            continue;
        }

        // Check for field schema (properties allowed on this type)
        if (def.fields) {
            for (var key in def.fields) {
                var innerSpec = def.fields[key];
                if (typeof innerSpec !== "object") continue;

                try {
                    // var baseType = innerSpec.type;
                    if (!innerSpec.type) throw new Error("No type in schema field");

                    // var noattrType = baseType.startsWith("fields.") ? baseType.replace("fields.", "fields.noattr.") : "fields.noattr." + baseType;
                    var fmod = fieldMap[innerSpec.type];//registry.find(innerSpec.type);
                    if (!fmod) {
                        //is the type in the registry and not yet loaded
                        fmod = registry.find(innerSpec.type);
                    }

                    if (!fmod || typeof fmod.validate !== "function") {
                        // console.error("Unknown field type in schema", innerSpec.type, "for field", key, "in", ns);
                        errors.push(_.errors.unknownFieldType.safe({
                            type: innerSpec.type,
                            key: key,
                            namespace: ns
                        }));
                        registry.remove(ns);
                        break;
                    }

                    // fmod.validate(innerSpec, undefined);
                } catch (e) {
                    console.error(e);
                    // errors.push(_.errors.invalidFieldDefinition.safe({
                    //     key: key,
                    //     reason: e.message,
                    //     namespace: ns
                    // }));
                    registry.remove(ns);
                    break;
                }
            }
        }

        // Register types
        if (def.type === "field") {
            // var fns = "fields." + def.namespace;
            fieldMap[def.namespace] = mod;

            if (def.alias) {
                var aliases = Array.isArray(def.alias) ? def.alias : [def.alias];
                for (var j = 0; j < aliases.length; j++) {
                    fieldMap[aliases[j]] = mod;
                }
            }
        } else if (def.type === "property") {
            propertyMap[def.namespace] = mod;
        }

    }

    // loadedTimes++;
    console.log(`Loaded fields.`);
} module.exports.Load = Load;


/**
 * Prevalkidates a field spec, and updates the data if needed.
 * Descructive changes may be made to the data.
 * @param {*} spec The field spec to validate against.
 * @param {*} data The data to validate.
 * @param {*} shorthand If true, expands shorthand in spec and data.
 */
function PreValidate(spec, data, shorthand = true) {

    if (!initialized) {
        _.errors.notInitalized.throw();
    }

    if (shorthand) {
        spec = shorthand.expand(spec, shorthand.jsonRenderShortHand);

        //if the data is an object, we can use shorthand to expand it
        if (typeof data === "object" && data !== null) {
            data = shorthand.expand(data, shorthand.jsonRenderShortHand);
        }

    }

    // // Global properties that must be applied before.
    // for (var prop in spec) {
    //     var pmod = propertyMap[prop];
    //     if (!pmod) continue;

    //     if (!(pmod.define.applyAttributeBeforeValidation === true)) {
    //         continue;
    //     }

    //     try {
    //         var outVal = pmod.validate(spec, data);
    //         if (pmod.define.mutates === true) {
    //             result.value = outVal;
    //         }
    //     } catch (e) {
    //         result.errors.push(e);
    //         result.success = false;
    //     }
    // }

    //prevalidate the spec
    for (var prop in spec) {
        var pmod = propertyMap[prop];
        if (!pmod) continue;

        if (typeof pmod.preValidate === "function") {
            try {
                var outVal = pmod.preValidate(spec, data);
                if (pmod.define.mutates === true) {
                    data = outVal;
                }
            } catch (e) {
                //ignore prevalidation errors
                console.warn("Prevalidation warning:", e);
            }
        }
    }

} module.exports.PreValidate = PreValidate;

/**
 * Supports shorthand expansion for the field spec & data spec.
 * Ensure you don't use the shorthand apprevations for field types.
 * This version does not support shorthand.
 * @param {*} spec Field definition object.
 * @param {*} data Data to validate against.
 * @returns {object} { value, errors[], success }
 */
function Validate(spec, data) {

    if (!initialized) {
        _.errors.notInitalized.throw();
    }

    spec = shorthand.expand(spec, shorthand.jsonRenderShortHand);

    //if the data is an object, we can use shorthand to expand it
    if (typeof data === "object" && data !== null) {
        data = shorthand.expand(data, shorthand.jsonRenderShortHand);
    }

    return Validate_NoShortHand(spec, data);
} module.exports.Validate = Validate;

/**
 * Validates a field spec against input data.
 * This version does not support shorthand.
 * @param {*} spec Field definition object.
 * @param {*} data Data to validate against.
 * @param {boolean} [throwErrors=false] If true, throws errors instead of returning them.
 * @returns {object} { value, errors[], success }
 */
function Validate_NoShortHand(spec, data, throwErrors = false) {

    // console.log("Validating", { spec, data });

    if (!initialized) {
        _.errors.notInitalized.throw();
    }

    var result = {namespace: "fields.validation", value: data, errors: [], success: true };

    var currentType = spec.type || "object";

    //incase the user included a type field in his top level spec
    if (typeof currentType === "object") {
        // If it's an object without fields, treat it as a simple object

        //if it's not an array, we can assume it's an object
        if (Array.isArray(currentType)) {
            currentType = "multiple";
        } else {
            currentType = "object";
        }

    }

    // Global properties that must be applied before.
    for (var prop in spec) {
        var pmod = propertyMap[prop];
        if (!pmod) continue;

        if (!(pmod.define.applyAttributeBeforeValidation === true)) {
            continue;
        }

        try {
            var outVal = pmod.validate(spec, data);
            if (pmod.define.mutates === true) {
                result.value = outVal;
            }
        } catch (e) {
            result.errors.push(e);
            result.success = false;
        }
    }

    //if it's not an array
    // if ((currentType === "object") && !(Array.isArray(spec.type))) {

        // Object-level (nested) validation
        if ((currentType === "object") && ("fields" in spec)) {
            var out = {};
            for (var key in spec.fields) {
                var childSpec = spec.fields[key];
                var childData = (data || {})[childSpec.name];
                var validated = Validate_NoShortHand(childSpec, childData);
                out[key] = validated;
                if (!validated.success) {
                    result.errors.push(...validated.errors);
                    result.success = false;
                }
            }

            // //append any extra fields that were not specified in the schema
            // for (var key in (data || {})) {
            //     if (out[key] === undefined) {
            //         out[key] = data[key];
            //         result.errors.push(_.errors.notSpecified.safe({ field: key }));
            //         result.success = false;
            //     }
            // }

            result.value = out;
            return result;
        } else if (currentType === "object") {
            //treat the simple object properties as unique fields
            var out = {};
            for (var key in spec) {
                var childSpec = spec[key];
                var childData = (data || {})[key];
                var validated = Validate_NoShortHand(childSpec, childData);
                out[key] = validated;
                if (!validated.success) {
                    result.errors.push(...validated.errors);
                    result.success = false;
                }

            }

            // //add any extra fields that were not specified in the schema
            // for (var key in (data || {})) {
            //     if (out[key] === undefined) {
            //         out[key] = data[key];
            //         result.errors.push(_.errors.notSpecified.safe({ field: key }));
            //         result.success = false;
            //     }
            // }

            result.value = out;
            return result;
        }
    // }

    //if the value is undefined, we can skip validation
    //required fields will throw an error during prevalidation

    if (data === undefined) {
        result.undefined = true;
        return result; //no validation needed
    }
    
    // is the spec.type just a string?
    if (typeof spec.type === "string") {
        spec.type = [spec.type];
    }

    //for each type in the array, validate against it - it must validate against at least one
    var typeSuccess = false;
    var typeErrors = [];

    for (var i = 0; i < spec.type.length; i++) {
        var fmod = fieldMap[spec.type[i]];
        if (!fmod) {
            typeErrors.push(_.errors.unknownFieldType.safe({ type: spec.type[i] }));
            // ReportUnknownField(spec.type[i]);
            continue;
        }

        try {
            fmod.validate(spec, data);
            typeSuccess = spec.type[i];
            break; //if one type succeeds, we are good
        } catch (e) {
            typeErrors.push(e);
            continue;
        }

    }


    if (!(typeSuccess)) {
        //is it only one type?
        if (spec.type.length === 1) {
            result.errors.push(...typeErrors);
        } else {
            result.errors.push(_.errors.unsupportedType.safe({
                type: spec.type.join(" or "),
                reason: typeErrors.length > 0 ? typeErrors[0].message : "No provided errors."
            }));
        }

        result.success = false;

    }


    // // Base field type
    // // var ftype = spec.type.startsWith("fields.") ? spec.type : "fields." + spec.type;
    // var fmod = fieldMap[spec.type];
    // if (!fmod) {
    //     _.errors.unknownFieldType.throw({ type: spec.type });
    // }

    // try {
    //     fmod.validate(spec, data);
    // } catch (e) {
    //     result.errors.push(e);
    //     result.success = false;
    //}

    // Global properties
    for (var prop in spec) {
        var pmod = propertyMap[prop];
        if (!pmod) continue;

        if (pmod.define.applyAttributeBeforeValidation === true) {
            continue;
        }

        try {
            var outVal = pmod.validate(spec, data);
            if (pmod.define.mutates === true) {
                result.value = outVal;
            }
        } catch (e) {
            result.errors.push(e);
            result.success = false;
        }
    }

    return result;
} //module.exports.Validate_NoShortHand = Validate_NoShortHand;

module.exports.GetRegistry = function() { return registry; };

/**
 * Validates a field specification recursively.
 * This function checks the structure, title, description, type, and fields of the spec.
 * It also checks for unknown properties and validates nested fields.
 * @param {*} spec Field specification object.
 * @param {*} throwErrors If true, throws errors instead of returning them.
 * @returns {object} { success: boolean, errors: array }
 */
function ValidateSpec(spec, throwErrors = false) {

    if (!initialized) {
        _.errors.notInitalized.throw();
    }

    var errors = ValidateSpecInternal(spec);

    if (errors.length > 0) {
        if (throwErrors) {
            _.errors.invalidSepcDefinition.throw(errors);
        } else {
            return {
                success: false,
                errors: errors,
            };
        }
    }

    return {
        success: true,
        errors: []
    };

} module.exports.ValidateSpec = ValidateSpec;

/**
 * Validates a field specification recursively.
 * This function checks the structure, title, description, type, and fields of the spec.
 * It also checks for unknown properties and validates nested fields.
 * @param {*} spec Field specification object.
 * @param {*} path Path to the current field in the spec, used for error reporting.
 * @returns {array} Array of error objects if validation fails, empty array if successful.
 */
function ValidateSpecInternal(spec, path="") {

    if (!initialized) {
        _.errors.notInitalized.throw();
    }

    var errors = [];

    if (typeof spec !== "object" || spec === null) {
        errors.push(_.errors.invalidFieldDefinition.safe({
            key: path || "root",
            reason: "Specification is not an object"
        }));
        return errors;
    }

    if (!spec.title) {
        errors.push(_.errors.missingTitle.safe({ namespace: path }));
    }

    if (!spec.description) {
        errors.push(_.errors.missingDescription.safe({ namespace: path }));
    }

    if (!spec.type) {
        errors.push(_.errors.unknownFieldType.safe({ type: "undefined" }));
    } else {

        //is the spec type a string?
        if (typeof spec.type === "string") {
            spec.type = [spec.type];
        }

        //now let's make sure every field type is valid
        for (var i = 0; i < spec.type.length; i++) {
            var fmod = fieldMap[spec.type[i]];
            if (!fmod) {
                errors.push(_.errors.unknownFieldType.safe({ type: spec.type[i], key: path || "root" }));
                // ReportUnknownField(spec.type[i]);
            }
        }

        // // is the spec an array?
        // if (typeof spec.type === "object") {
        //     if (Array.isArray(spec.type)) {
        //         if (spec.type.length === 0) {
        //             errors.push(_.errors.emptyTypeArray.sade({
        //                 key: path || "root"
        //             }));
        //         }

        //         for (var i = 0; i < spec.type.length; i++) {
        //             var fmod = fieldMap[spec.type[i]];
        //             if (!fmod) {
        //                 errors.push(_.errors.unknownFieldType.safe({ type: spec.type }));
        //             }
        //         }
        //     } else {
        //         errors.push(_.errors.invalidFieldType.safe({ type: "object" }));
        //     }

        // }

        // var fmod = fieldMap[spec.type];
        // if (!fmod) {
        //     errors.push(_.errors.unknownFieldType.safe({ type: spec.type }));
        // }

    }

    // for (var prop in spec) {
    //     if (["title", "description", "type", "fields", "alias", "use"].includes(prop)) continue;
    //     if (!propertyMap[prop]) {

    //         //is the property in the spec?


    //         errors.push(_.errors.unkownProperty.safe({ property: prop, namespace: path }));
    //     }
    // }

    if (spec.fields && typeof spec.fields === "object") {
        for (var key in spec.fields) {
            var subErrors = ValidateSpecInternal(spec.fields[key], (path ? path + "." : "") + key);
            errors.push(...subErrors);
        }
    }

    return errors;
} //module.exports.ValidateSpecInternal = ValidateSpecInternal;

/**
 * Reports if the fields module has been initialized.
 * @returns {boolean} True if initialized, false otherwise.
 */
function isInitialized() {
    return initialized;
} module.exports.isInitialized = isInitialized;

/**
 * Reports an unknown field type to a log file for later review.
 * This is ASYNC as to not stop the main system.
 * @param {*} type The field type to report.
 */
async function ReportUnknownField(type) {
    var currentUnknownTypes = [];

    try {
        currentUnknownTypes = fm.LoadLogJSON("fields.unknowntypes");
    } catch (error) {
        // console.error(error);
    }

    //add the type uniquely
    if (!currentUnknownTypes.includes(type)) {
        currentUnknownTypes.push(type);
        fm.SaveLogJSON("fields.unknowntypes", currentUnknownTypes);
    }
    


}